import { apiInternetBase, HttpType, openLoading } from 'gf-ui';

export class apiCefalee extends apiInternetBase {
  constructor(root, dispatch, apiCallback, token) {
    super(dispatch, apiCallback, token, root)
  }

  #elenco = (cb) => this._getJson(HttpType.POST, `/elenco`, cb, this.token);
  #salva = (cb) => this._getJson(HttpType.POST, '/salva', cb, this.token);    
  #salvaAllegati = (cb) => this._getJson(HttpType.POST, '/salva-allegati', cb, this.token);    

  fnElenco = (fnReturn, params, fnError) => {
    openLoading(this.dispatch)
    this.setParams(params);
    this.#elenco((status, res) => this.apiCallback(status, res, fnReturn, fnError))
  }

  fnSalva = (fnReturn, params, fnError) => {
    openLoading(this.dispatch);
    this.setParams(params);
    this.#salva((status, res) => this.apiCallback(status, res, fnReturn, fnError))
  }

  fnSalvaAllegati = (fnReturn, params, fnError) => {
    openLoading(this.dispatch);
    this.setParams(params);
    this.#salvaAllegati((status, res) => this.apiCallback(status, res, fnReturn, fnError))
  }
}